module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-portal-2.abd122f0.svg";